import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import {
  convertFromPayoffRequestResponseArrayToPayoffRequestDataArray,
  convertFromPayoffRequestResponseToPayoffRequestData,
  IPayoffRequestData,
  IPayoffRequestResponse,
} from '../../../types/order/title/IPayoffRequest';
import { baseUrlService } from '../../../ui-toolkit/rest/BaseUrlService';

export const getPayoffHistoryAsync = async (orderId: string): Promise<IPayoffRequestData[]> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<IPayoffRequestResponse[]>(`/timber/api/internal/orders/${orderId}/mortgage-payoffs`)
    .then((response) => convertFromPayoffRequestResponseArrayToPayoffRequestDataArray(response.data))
    .catch(axiosErrorHandler);

export const createPayoffAsync = async (orderId: string): Promise<IPayoffRequestData> =>
  APIFactory(baseUrlService.ApiLocation)
    .post<IPayoffRequestResponse>(`/timber/api/internal/orders/${orderId}/mortgage-payoffs`, {})
    .then((response) => convertFromPayoffRequestResponseToPayoffRequestData(response.data))
    .catch(axiosErrorHandler);

export const cancelPayoffAsync = async (orderId: string, PayoffId: string): Promise<IPayoffRequestData> =>
  APIFactory(baseUrlService.ApiLocation)
    .delete<IPayoffRequestResponse>(`/timber/api/internal/orders/${orderId}/mortgage-payoffs/${PayoffId}`)
    .then((response) => convertFromPayoffRequestResponseToPayoffRequestData(response.data))
    .catch(axiosErrorHandler);
